import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a91ce43c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row row-body-scheme" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "row row-body-scheme" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "row row-body-scheme" }
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = { class: "row row-body-scheme" }
const _hoisted_8 = { class: "col-auto" }
const _hoisted_9 = {
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row row-body-scheme-buttons" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-auto" }),
  /*#__PURE__*/_createElementVNode("div", { class: "col-auto" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_ColorPicker = _resolveComponent("ColorPicker")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('bodyScheme'),
        mb: 5,
        "show-refresh-button": "",
        onRefresh: _ctx.reloadContent,
        "back-route": _ctx.returnRouteObject
      }, null, 8, ["title", "onRefresh", "back-route"]),
      _createVNode(_component_AlertError2, {
        error: _ctx.pageUI.getError(),
        class: "mb-5"
      }, null, 8, ["error"]),
      _createVNode(_component_BaseSpinner, {
        spin: _ctx.pageUI.isNotReady()
      }, null, 8, ["spin"]),
      (_ctx.pageUI.isReady())
        ? (_openBlock(), _createBlock(_component_dp_form, {
            key: 0,
            onSubmit: _ctx.submitData,
            as: "form",
            novalidate: ""
          }, {
            default: _withCtx(({ errors }) => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_ColorPicker, {
                    modelValue: _ctx.bodyScheme.background_color,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bodyScheme.background_color) = $event)),
                    label: _ctx.$t('backgroundColor'),
                    name: "backgroundColor"
                  }, null, 8, ["modelValue", "label"])
                ])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_ColorPicker, {
                    modelValue: _ctx.bodyScheme.text_color,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bodyScheme.text_color) = $event)),
                    label: _ctx.$t('textColor'),
                    name: "textColor"
                  }, null, 8, ["modelValue", "label"])
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_InputNumber, {
                    modelValue: _ctx.bodyScheme.root_font_size_in_px,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bodyScheme.root_font_size_in_px) = $event)),
                    label: _ctx.$t('fontSize'),
                    name: "root_font_size_in_px",
                    min: 0,
                    step: .01,
                    rules: "required",
                    errors: errors,
                    mode: "group-end",
                    "addon-text": "px"
                  }, null, 8, ["modelValue", "label", "errors"])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_InputNumber, {
                    modelValue: _ctx.bodyScheme.line_height_size_in_perc,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bodyScheme.line_height_size_in_perc) = $event)),
                    label: _ctx.$t('lineHeight'),
                    name: "line_height_size_in_perc",
                    min: 0,
                    step: .01,
                    rules: "required",
                    errors: errors,
                    mode: "group-end"
                  }, null, 8, ["modelValue", "label", "errors"])
                ])
              ]),
              _createElementVNode("button", _hoisted_9, _toDisplayString(_ctx.$t('save')), 1),
              _createElementVNode("button", {
                class: "btn btn-secondary ms-3",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.resetToDefaults()), ["prevent"]))
              }, _toDisplayString(_ctx.$t('restoreDefaultValues')), 1),
              _hoisted_10
            ]),
            _: 1
          }, 8, ["onSubmit"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}